import { z } from 'zod';

import type { AppNotification, NotificationSettings } from './types';

export const notificationCategorySchema = z.enum([
  'general',
  'subscription',
  'schedule_commands',
  'device',
  'alerts',
]);

export const notificationTargetKindSchema = z.enum([
  'device',
  'subscription',
  'warranty_claim',
  'support_ticket',
]);

export const notificationDeepLinkSchema = z.object({
  kind: notificationTargetKindSchema,
  targetId: z.string(),
});

export const notificationSchema: z.ZodType<AppNotification> = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  deviceName: z.string().nullable(),
  serial: z.string().nullable(),
  timestamp: z.string(),
  read: z.boolean(),
  critical: z.boolean(),
  category: notificationCategorySchema,
  deepLink: notificationDeepLinkSchema.nullable(),
});

/** `GET /notifications` → list + unread count for the bell badge. */
export const notificationListResponseSchema = z.object({
  data: z.array(notificationSchema),
  meta: z.object({ unread: z.number() }),
});

export type NotificationListResponse = z.infer<typeof notificationListResponseSchema>;

/** `GET`/`PATCH /notifications/settings` → the grower's delivery preferences. */
export const notificationSettingsSchema: z.ZodType<NotificationSettings> = z.object({
  general: z.boolean(),
  subscription: z.boolean(),
  scheduleCommands: z.boolean(),
  device: z.boolean(),
});
